import { render, staticRenderFns } from "./highTask.vue?vue&type=template&id=f7845940&scoped=true&"
import script from "./highTask.vue?vue&type=script&lang=js&"
export * from "./highTask.vue?vue&type=script&lang=js&"
import style0 from "./highTask.vue?vue&type=style&index=0&id=f7845940&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7845940",
  null
  
)

export default component.exports